export enum AssessmentQuestionTabCategory {
  Conteudo,
  MaterialDidatico,
  MatrizCurricular,
}
